import { BaseTable, Card, FooterMenu, Loading, PaginationData, SummaryBox } from "components"
import React, { Fragment, useState } from "react"
import { Filter, Item } from "./components"
import { FilterType } from "./types"
import { defaultFilter, useExportPdfAgedReceiveable, useList } from "./utils"
import { calculateSummary, exportExcelAgedReceivable } from "./utils/functions"
import moment from "moment"


export const dataContextAged = React.createContext({
  currentPage: 1,
  limit: 10,
  size: 1,
  total: 0,
})

export function TabAgedReceivable() {
  const [selected, setSelected] = useState<FilterType>(defaultFilter)
  const { data, isLoading } = useList(selected)

  const exportDateFormat = `${moment(selected.start_date).format(
    "DD/MM/YYYY"
  )} - ${moment(selected.end_date).format("DD/MM/YYYY")}`

  const exportPdf = useExportPdfAgedReceiveable({
    data: data.payload,
    dateFilter: exportDateFormat
  })

  // Vars
  const summary = calculateSummary(data?.payload)

  return (
    <Fragment>
      <section className="mt-2">
        <Card>
          <Card.Body>
            <Filter selected={selected} setSelected={setSelected} />
          </Card.Body>
        </Card>
      </section>

      <section className="mt-2">
        <Card>
          <Card.Body>
            <div className="overflow-x-auto max-h-[calc(100vh-600px)]">
              <BaseTable>
                <thead className="!bg-black !text-white">
                  <tr>
                    <th>No</th>
                    <th colSpan={2}>INVOICE ID#</th>
                    <th>REF SO ID#</th>
                    <th>DATE</th>
                    <th>CUSTOMER</th>
                    <th>TOTAL</th>
                    <th>7 DAYS</th>
                    <th>15 DAYS</th>
                    <th>21 DAYS</th>
                    <th>30 DAYS</th>
                    <th>60+ DAYS</th>
                  </tr>
                </thead>
                <tbody>
                  <dataContextAged.Provider
                    value={{
                      currentPage: selected.page,
                      limit: selected.limit,
                      size: data.pagination_data.size,
                      total: selected.total
                    }}
                  >
                    {isLoading || data?.payload?.length === 0 ? (
                      <tr>
                        <td colSpan={15} className="text-center">
                          <Loading
                            loading={isLoading}
                            errorText={isLoading ? "" : "No data available"}
                          />
                        </td>
                      </tr>
                    ) : (
                      data?.payload?.map((item: any, key: number) => (
                        <Item data={item} index={key} />
                      ))
                    )}
                  </dataContextAged.Provider>
                </tbody>
              </BaseTable>
              <div className="mt-5">
                <PaginationData
                  data={data}
                  pagination={selected}
                  setPagination={setSelected}
                />
              </div>
            </div>
          </Card.Body>
        </Card>
      </section>

      <section className="mt-2">
        <FooterMenu
          export={{
            actiontype: "export",
            onClick: () =>
              exportExcelAgedReceivable({
                data: data.payload,
                dateFilter: exportDateFormat
              })
          }}
          pdf={{
            actiontype: "pdf",
            onClick: exportPdf.handleExportPdf
          }}
          customRightElement={
            <section className="flex gap-3">
              <SummaryBox label="Total" amount={summary.balance} />

              <SummaryBox label="7 Days" amount={summary["7_day"]} />

              <SummaryBox label="15 Days" amount={summary["15_day"]} />

              <SummaryBox label="21 Days" amount={summary["21_day"]} />

              <SummaryBox label="30 Days" amount={summary["30_day"]} />

              <SummaryBox label="60+ Days" amount={summary["60_day"]} />
            </section>
          }
        />
      </section>
    </Fragment>
  )
}
